export default __webpack_public_path__ + "static/mc-tagging-46e2a05dbc616854f3d9f76901a62b40.mp4";